import algoliasearch from "algoliasearch/lite";
import instantsearch from "instantsearch.js";
import { connectVoiceSearch } from "instantsearch.js/es/connectors";

export function init() {
    // Autofocus keyword fields
    const input = document.querySelector(".js-search-keywords"),
        end = input?.value.length;

    input?.setSelectionRange(end, end);
    input?.focus();

    if (
        typeof window.SpeechRecognition != "undefined" ||
        typeof webkitSpeechRecognition != "undefined"
    ) {
        document
            .querySelector(".js-speech-to-search")
            .classList.remove("hidden");

        // Create a render function
        buildSpeechToSearch();
    }

    htmx.on("htmx:afterSwap", function (event) {
        if (event.target.id === "search-component") {
            buildSpeechToSearch();
        }
    });
}

function buildSpeechToSearch() {
    const renderVoiceSearch = (renderOptions, isFirstRender) => {
        const { isListening, toggleListening, voiceListeningState } =
            renderOptions;
        const { status, transcript, isSpeechFinal, errorCode } =
            voiceListeningState;

        const container = document.querySelector(".js-search"),
            button = document.querySelector(".js-speech-to-search"),
            microphoneInner = button?.querySelector(".js-microphone-inner");

        if (isFirstRender) {
            // const button = document.createElement('button');
            button.addEventListener("click", (event) => {
                toggleListening();
            });
        }

        if (isListening) {
            microphoneInner.style.fill = "#2949E1";
        } else {
            microphoneInner.style.fill = "";
        }

        // if (status == 'finished' && searchInput) {
        if (isSpeechFinal && status == "finished" && transcript) {
            // Set keyword field value
            const input = document.querySelector(".js-search-keywords");
            let event = new Event("keyup");

            input.value = transcript;

            input.dispatchEvent(event);
        }
    };

    // create custom widgets
    const customVoiceSearch = connectVoiceSearch(renderVoiceSearch);

    const searchClient = algoliasearch(
        "JOUS0LKT85",
        "6b9fc21e8e5e69fade2ddec38e375e1c"
    );

    const search = instantsearch({
        indexName: "prod_craft_search",
        future: {
            preserveSharedStateOnUnmount: true,
        },
        searchClient,
    });

    // instantiate custom widget
    search.addWidgets([
        customVoiceSearch({
            container: document.querySelector(".js-search"),
        }),
    ]);

    search.start();
}
